module.exports = __webpack_public_path__ + "5018db64b7e005d3879965b2a501b567.MP3";